module.exports = __webpack_public_path__ + "static/media/coupa.ad90e048.png";